const firebaseConfig = {
  apiKey: "AIzaSyBf5zzdkbBMml5M2CNc_AtOns3WowfcLZQ",
  authDomain: "simple-firebase-authenti-63acb.firebaseapp.com",
  projectId: "simple-firebase-authenti-63acb",
  storageBucket: "simple-firebase-authenti-63acb.appspot.com",
  messagingSenderId: "636846459691",
  appId: "1:636846459691:web:7f912b9bb20af9ced0d36e",
};
export default firebaseConfig;